/*
*@Author: dcl
*@Description: 营业执照页面
*@Date: 2022-11-14 11:26:18
*/
<template>
    <div class="ibu">
      <el-image :src="info_2" />
    </div>
  </template>
  
  <script>
  export default {
      data() {
          return {
              info_2 :require('../../assets/info_2.png')
          }
      }
  }
  </script>
  
  <style scoped lang="less">
    .ibu img {
        width: 100%;
    }
  </style>


// WEBPACK FOOTER //
// src/view/Information/business.vue